<template>
  <div class="training-form">
    <form class="page-content -column -column-one -form" @submit.prevent>
      <ul v-if="uncategorizedMessage" class="training-type">
        <!--
        -->
        <li><a href="#" :class="{ '-active': method === 'manual' }" @click.prevent="setMethod('manual')">Manual</a></li>
        <!--
        -->
        <li>
          <a href="#" :class="{ '-active': method === 'auto' }" @click.prevent="setMethod('auto')"
            >Uncategorized messages</a
          >
        </li>
      </ul>

      <div class="uncategorized-message">
        <div v-if="method === 'manual'">
          <label>Manual message:</label>
          <textarea v-model="manualMessage"></textarea>
          <action-button :state="manualTestState" :text="'Test'" @pressed="getManualMessageCategory"></action-button>
          <!-- <a href="#" @click.prevent="getManualMessageCategory()">Test</a> -->
        </div>

        <div v-if="method === 'auto' && uncategorizedMessage">
          <label>Uncategorized message:</label>
          <textarea v-model="uncategorizedMessage.message"></textarea>
          <a href="#" @click.prevent="skip()">Skip</a>
        </div>
      </div>

      <div v-if="suggestionStats.length" class="suggested-stats -headings">
        <table>
          <tr>
            <th class="label">Label</th>
            <th class="classifier">Classifier</th>
            <th class="keywords">Keywords</th>
            <th class="weighting">Weighting</th>
            <th class="score">Score</th>
          </tr>
        </table>
      </div>

      <div v-if="suggestionStats.length" class="suggested-stats -results">
        <table>
          <tr v-for="stats in suggestionStats" :key="stats.label">
            <td class="label">{{ stats.label }}</td>
            <td class="classifier">{{ stats.classifier_score }}%</td>
            <td class="keywords">{{ stats.keyword_score }}%</td>
            <td class="weighting">{{ stats.weighting }}</td>
            <td class="score">{{ stats.score }}%</td>
          </tr>
        </table>
      </div>

      <training-dataset-list></training-dataset-list>
    </form>

    <div class="page-content -column -column-two">
      <category-list
        :categories="organisedCategories"
        :suggested-category-label="suggestedCategoryLabel"
        @categoryClicked="selectCategory"
      >
      </category-list>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import { mapGetters } from "vuex";

import actionButton from "@/components/actionButton";
import categoryList from "@/components/categoryList";
import trainingDatasetList from "@/components/trainingDatasetList";
import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const messagesSource = 'categorized_messages';
const queriesSource = 'queries/suggest';

export default {
  components: {
    actionButton,
    categoryList,
    trainingDatasetList
  },

  data() {
    return {
      method: "auto",
      manualMessage: "",
      uncategorizedMessage: null,
      creatingMessage: false,
      categorizingMessage: false,
      suggestedCategoryLabel: null,
      suggestionStats: [],
      manualTestState: "normal"
    };
  },

  computed: {
    ...mapGetters(["organisedCategories"])
  },

  created() {
    this.getUncategorizedMessage();
  },

  methods: {
    getUncategorizedMessage() {
      api
        .instance()
        .get(`${apiVersion}/${messagesSource}`, { params: { team_id: auth.teamId(), status: "new", per_page: 1 } })
        .then((resp) => {
          const msgs = resp.data.data;

          if (msgs.length) {
            this.uncategorizedMessage = msgs[0].attributes;
            this.getSuggestedCategory(this.uncategorizedMessage.message);
          } else {
            this.uncategorizedMessage = null;
            this.method = "manual";
          }
        });
    },

    setMethod(method) {
      this.method = method;

      if (this.method === "auto") {
        this.getSuggestedCategory(this.uncategorizedMessage.message);
      } else if (this.manualMessage.length) {
        this.getSuggestedCategory(this.manualMessage);
      } else {
        this.suggestedCategoryLabel = null;
        this.suggestionStats = [];
      }
    },

    selectCategory(category) {
      if (category.children) {
        console.error("Cannot categorize a parent category");
        return;
      }

      this.suggestionStats = [];

      if (this.method === "auto") {
        this.categorizeMessage(this.uncategorizedMessage.id, [category.id], this.uncategorizedMessage.message);
        return;
      }

      if (this.creatingMessage) return;
      if (!this.manualMessage.length) return;
      this.creatingMessage = true;

      api
        .instance()
        .post(`${apiVersion}/${messagesSource}`, { team_id: auth.teamId(), message: this.manualMessage })
        .then((resp) => {
          this.creatingMessage = false;
          this.manualMessage = "";
          this.categorizeMessage(resp.data.data.attributes.id, [category.id]);
        })
        .catch((err) => {
          console.error("Error creating message:", err);
        });
    },

    skip() {
      this.suggestionStats = [];
      this.categorizeMessage(this.uncategorizedMessage.id, []);
    },

    categorizeMessage(messageId, categoryIds, message) {
      if (this.categorizingMessage) return;
      this.categorizingMessage = true;

      const params = { team_id: auth.teamId(), category_ids: categoryIds };
      if (message) params.message = message;

      api
        .instance()
        .put(`${apiVersion}/${messagesSource}/${messageId}`, params)
        .then((resp) => {
          this.incrementCategoriesMessageCount(categoryIds, this.organisedCategories);
          this.getUncategorizedMessage();
          this.categorizingMessage = false;
        })
        .catch((err) => {
          console.error("Error categorizing message:", err);
          this.categorizingMessage = false;
        });
    },

    getSuggestedCategory(message, callback = null) {
      this.suggestedCategoryLabel = null;

      api
        .instance()
        .post(`/${apiVersion}/${queriesSource}`, { team_id: auth.teamId(), message: message })
        .then((resp) => {
          this.suggestionStats = resp.data.stats || [];

          if (resp.data.category) {
            this.suggestedCategoryLabel = resp.data.category.data.attributes.label;
          }

          if (callback) callback();
        })
        .catch((err) => {
          console.error("Error fetching suggested category:", err);
        });
    },

    incrementCategoriesMessageCount(categoryIds, categories) {
      _.each(categories, (cat) => {
        if (_.contains(categoryIds, cat.id)) {
          cat.categorized_messages_count += 1;
        }

        if (cat.children) {
          this.incrementCategoriesMessageCount(categoryIds, cat.children);
        }
      });
    },

    getManualMessageCategory() {
      this.manualTestState = "loading";
      this.suggestionStats = [];

      this.getSuggestedCategory(this.manualMessage, () => {
        this.manualTestState = "normal";
      });
    }
  }
};
</script>
